import { styled } from '@mui/material';
import FooterBackground from '@assets/images/FooterBackground.png';

export const Styles = {
  FooterContainer: styled('footer')(({ theme }) => ({
    width: '100%',
    minHeight: '300px',
    display: 'flex',
    justifyContent: 'center',
    backgroundImage: `url(${FooterBackground})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    padding: '10px',
    [theme.breakpoints.down('md')]: {
      height: 'auto',
      padding: '30px 15px'
    }
  })),

  FooterContent: styled('div')(({ theme }) => ({
    width: '100%',
    maxWidth: '1200px',
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: '40px'
    }
  })),

  ContactsContainer: styled('div')(({ theme }) => ({
    maxWidth: '33%',
    [theme.breakpoints.down('md')]: {
      order: 3,
      maxWidth: '100%',
      padding: 0
    }
  })),

  Title: styled('h1')({
    color: '#afc9d7',
    textShadow: '1px 2px 1px rgba(0, 0, 0, 0.5)',
    marginBottom: '20px',
    fontSize: '14px',
    fontWeight: '600'
  }),

  TopContainer: styled('div')({
    display: 'flex'
  }),

  BaseContainer: styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'right'
    }
  })),

  MapInfo: styled('div')(({ theme }) => ({
    width: '380px',
    height: '200px',
    borderRadius: '4px',
    overflow: 'hidden',
    //border: '4px solid rgb(0, 0, 0)',
    flexShrink: 0,
    [theme.breakpoints.down('md')]: {
      width: '100%',
      height: '150px'
    }
  })),

  ContactInfo: styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '7px'
  })),

  ContactBox: styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    maxWidth: '100%',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      marginLeft: '0',
      padding: '0'
    }
  })),

  IconImg: styled('img')(({ theme }) => ({
    width: '20px',
    marginTop: '4%',
    marginRight: '3%',
    height: '20px',
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  })),

  Text: styled('span')(({ theme }) => ({
    color: '#8c929aff',
    fontSize: '12px',
    paddingLeft: '10px'
    // [theme.breakpoints.down('md')]: {
    //   fontSize: '12px',
    //   paddingLeft: '0',
    //   marginTop: '-4%'
    // }
  })),

  ListContainer: styled('div')(({ theme }) => ({
    flexGrow: 1,
    maxWidth: '31%',
    marginLeft: 35,
    [theme.breakpoints.down('md')]: {
      order: 1,
      maxWidth: '100%',
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      margin: '0 auto',
      padding: '0 15px'
    }
  })),

  FooterLinks: styled('div')(({ theme }) => ({
    // gap: '10px 30px',
    display: 'flex',
    justifyContent: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      justifyItems: 'center',
      maxWidth: '400px',
      width: '100%'
    }
  })),

  ItemWithBorder: styled('span')(({ theme }) => ({
    fontSize: '12px',
    fontWeight: '400',
    fontFamily:
      '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
    textShadow: '1px 2px 1px rgba(0, 0, 0, 0.5)',
    color: '#afc9d7',
    paddingBottom: 9,
    borderBottom: '0.5px solid #6d6a75',
    display: 'flex',
    justifyContent: 'flex-start',
    [theme.breakpoints.down('md')]: {
      fontSize: '10px',
      padding: '4px 0',
      textAlign: 'left',
      margin: '0 auto',
      width: '100%'
    }
  })),

  UlOn: styled('ul')({
    flexGrow: 1,
    margin: 0,
    padding: 0
  }),

  LiOn: styled('li')(({ theme }) => ({
    lineHeight: '18px',
    paddingBottom: '15px',
    fontSize: '10px',
    color: 'white',
    textAlign: 'center',
    position: 'relative',
    listStyle: 'none'
  })),

  RightsContainer: styled('div')(({ theme }) => ({
    maxWidth: '30%',
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      order: 2,
      margin: '0 auto',
      alignItems: 'center !important'
    }
  })),

  RightsText: styled('p')(({ theme }) => ({
    color: '#afc9d7',
    fontSize: '8.5px',
    textAlign: 'center',
    margin: '2px 0',
    [theme.breakpoints.down('md')]: {
      fontSize: '10px',
      margin: '2px auto',
      display: 'flex',
      justifyContent: 'center'
    }
  })),

  LogoImg: styled('img')(({ theme }) => ({
    width: '60%',
    height: 'auto',
    display: 'block',
    margin: '0 auto',
    [theme.breakpoints.down('md')]: {
      width: '80%'
    }
  })),

  LogoContainer: styled('div')(({ theme }) => ({
    borderRadius: '0',
    marginBottom: '5px',
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      width: '90%',
      maxWidth: '280px',
      margin: '0 auto'
    }
  }))
};
